import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createSlots as _createSlots, createVNode as _createVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-44041eec"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "base-title-button"
}
const _hoisted_2 = ["href"]
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "mas fw-light" }, "open_in_new", -1))
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col-12" }
const _hoisted_6 = { class: "name" }
const _hoisted_7 = {
  key: 0,
  class: "global-forced-include mt-3"
}
const _hoisted_8 = { class: "bg-white border border-1 rounded p-3 mb-3" }
const _hoisted_9 = { class: "mb-3" }
const _hoisted_10 = { class: "fs-5 lh-sm text-white bg-primary rounded m-0 px-2 py-1" }
const _hoisted_11 = { class: "row" }
const _hoisted_12 = { class: "col-3" }
const _hoisted_13 = {
  key: 0,
  class: "product-card border border-1 rounded mx-auto"
}
const _hoisted_14 = { class: "position-relative sma-font-fam" }
const _hoisted_15 = ["src", "alt"]
const _hoisted_16 = { class: "card-body sma-font-fam px-2" }
const _hoisted_17 = { key: 1 }
const _hoisted_18 = { class: "col-1 d-flex flex-column justify-content-end" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "mas" }, "edit", -1))
const _hoisted_20 = { class: "text-muted ms-3" }
const _hoisted_21 = { class: "wrapper bg-light rounded p-3" }
const _hoisted_22 = { class: "col-12 mb-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseTitle = _resolveComponent("BaseTitle")!
  const _component_input_text = _resolveComponent("input-text")!
  const _component_ProductFilter = _resolveComponent("ProductFilter")!
  const _component_MultilingualSwitcher = _resolveComponent("MultilingualSwitcher")!
  const _component_RenderedProductLabel = _resolveComponent("RenderedProductLabel")!
  const _component_base_offcanvas_button_open = _resolveComponent("base-offcanvas-button-open")!
  const _component_GenericFormWrapper = _resolveComponent("GenericFormWrapper")!
  const _component_ProductLabel = _resolveComponent("ProductLabel")!
  const _component_discount_pricelist_section = _resolveComponent("discount-pricelist-section")!
  const _component_base_offcanvas = _resolveComponent("base-offcanvas")!
  const _component_base_container = _resolveComponent("base-container")!
  const _component_CatalogBuildStatus = _resolveComponent("CatalogBuildStatus")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_base_container, { "has-build-status-on-page": "" }, {
      default: _withCtx(() => [
        _createVNode(_component_BaseTitle, {
          title: _ctx.$t('productFilter'),
          "back-route": _ctx.returnRouteObject,
          mode: _ctx.mode,
          "help-text": _ctx.$t('descriptionProductFiltersDetail'),
          mb: 5,
          "show-refresh-button": "",
          onRefresh: _ctx.reloadContent
        }, _createSlots({ _: 2 }, [
          (_ctx.pageUI.getIsReady())
            ? {
                name: "buttons",
                fn: _withCtx(() => [
                  (_ctx.mode === _ctx.PageDetailModeEnum.EDIT && _ctx.previewUrl)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                        _createElementVNode("a", {
                          href: _ctx.previewUrl,
                          target: "_blank",
                          class: "btn btn-hover icon-link"
                        }, [
                          _hoisted_3,
                          _createTextVNode(_toDisplayString('Preview'))
                        ], 8, _hoisted_2)
                      ]))
                    : _createCommentVNode("", true)
                ]),
                key: "0"
              }
            : undefined
        ]), 1032, ["title", "back-route", "mode", "help-text", "onRefresh"]),
        _createVNode(_component_GenericFormWrapper, {
          submitData: _ctx.submitData,
          pageUI: _ctx.pageUI,
          buttonClass: "btn-sm"
        }, {
          content: _withCtx(({errors}) => [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createVNode(_component_input_text, {
                    modelValue: _ctx.productFilter.name,
                    "onUpdate:modelValue": [
                      _cache[0] || (_cache[0] = ($event: any) => ((_ctx.productFilter.name) = $event)),
                      _ctx.onFormDataChanged
                    ],
                    label: _ctx.$t('name'),
                    name: "name",
                    rules: "required",
                    errors: errors
                  }, null, 8, ["modelValue", "label", "errors", "onUpdate:modelValue"])
                ]),
                _createVNode(_component_ProductFilter, {
                  "is-all-products-filter-allowed": _ctx.productFilter.code === 'DELIVERY_BY_SHIPPING_SUPPORTED',
                  modelValue: _ctx.productFilter,
                  "onUpdate:modelValue": [
                    _cache[1] || (_cache[1] = ($event: any) => ((_ctx.productFilter) = $event)),
                    _ctx.onFormDataChanged
                  ],
                  errors: errors
                }, null, 8, ["is-all-products-filter-allowed", "modelValue", "errors", "onUpdate:modelValue"]),
                (_ctx.mode === _ctx.PageDetailModeEnum.EDIT)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                      _createElementVNode("section", _hoisted_8, [
                        _createElementVNode("header", _hoisted_9, [
                          _createElementVNode("h3", _hoisted_10, _toDisplayString(_ctx.$t('productLabel')), 1)
                        ]),
                        _createVNode(_component_MultilingualSwitcher, {
                          class: "col-8",
                          errors: errors,
                          "active-language": _ctx.activeLanguage,
                          mb: 2,
                          onUpdateActiveLanguage: _cache[2] || (_cache[2] = (newValue) => _ctx.activeLanguage = newValue)
                        }, null, 8, ["errors", "active-language"]),
                        _createElementVNode("div", _hoisted_11, [
                          _createElementVNode("div", _hoisted_12, [
                            (_ctx.productLabel)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                                  _createElementVNode("div", _hoisted_14, [
                                    _createVNode(_component_RenderedProductLabel, {
                                      "active-language": _ctx.activeLanguage,
                                      "product-label": _ctx.productLabel,
                                      "color-scheme": _ctx.colorScheme,
                                      positioned: ""
                                    }, null, 8, ["active-language", "product-label", "color-scheme"]),
                                    _createElementVNode("img", {
                                      src: require('@/assets/images/product-card-discount/product_card.png'),
                                      class: _normalizeClass(['top img-fluid w-100 rounded-top']),
                                      alt: _ctx.$t('discountShowAsFollows')
                                    }, null, 8, _hoisted_15)
                                  ]),
                                  _createElementVNode("div", _hoisted_16, [
                                    _createElementVNode("p", {
                                      class: "name mb-2",
                                      style: _normalizeStyle('color: ' + _ctx.colorScheme.text_color_on_light_color)
                                    }, _toDisplayString(_ctx.$t('productName')), 5)
                                  ])
                                ]))
                              : (_openBlock(), _createElementBlock("div", _hoisted_17, [
                                  _createVNode(_component_RenderedProductLabel, {
                                    "active-language": _ctx.activeLanguage,
                                    "product-label": _ctx.productLabel,
                                    "color-scheme": _ctx.colorScheme
                                  }, null, 8, ["active-language", "product-label", "color-scheme"])
                                ]))
                          ]),
                          _createElementVNode("div", _hoisted_18, [
                            _createVNode(_component_base_offcanvas_button_open, {
                              "offcanvas-id": "offcanvas-label",
                              class: "btn btn-icon btn-primary mt-3 align-self-end"
                            }, {
                              default: _withCtx(() => [
                                _hoisted_19
                              ]),
                              _: 1
                            })
                          ])
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])
          ]),
          _: 1
        }, 8, ["submitData", "pageUI"]),
        _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.$t('cachingDelayMinutes', [5])), 1),
        _createVNode(_component_base_offcanvas, {
          title: _ctx.$t('productLabel'),
          id: "offcanvas-label",
          label: "offcanvasEditColumn",
          class: "offcanvas-wide"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_21, [
              _createVNode(_component_MultilingualSwitcher, {
                class: "col-12",
                errors: _ctx.languageSwitchErrors,
                "active-language": _ctx.activeLanguage,
                mb: 2,
                onUpdateActiveLanguage: _cache[3] || (_cache[3] = (newValue) => _ctx.activeLanguage = newValue)
              }, null, 8, ["errors", "active-language"]),
              _createVNode(_component_discount_pricelist_section, {
                class: "discount-client-group mb-3",
                title: _ctx.$t('label'),
                icon: "label"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_22, [
                    _createElementVNode("div", null, [
                      _createVNode(_component_ProductLabel, {
                        "active-language": _ctx.activeLanguage,
                        "product-filter-code": _ctx.code,
                        onProductLabelUpdated: _ctx.reloadLabel
                      }, null, 8, ["active-language", "product-filter-code", "onProductLabelUpdated"])
                    ])
                  ])
                ]),
                _: 1
              }, 8, ["title"])
            ])
          ]),
          _: 1
        }, 8, ["title"])
      ]),
      _: 1
    }),
    _createVNode(_component_CatalogBuildStatus)
  ], 64))
}